<template>
  <component :is="receiptDescriptionData === undefined ? 'div' : 'b-card'">
    <b-alert variant="danger" :show="receiptDescriptionData === undefined">
      <h4 class="alert-heading">獲取印章數據時出錯</h4>
      <div class="alert-body">
        找不到相關款項章記錄。請查看
        <b-link class="alert-link" :to="{ name: 'receipt-descriptions-list' }">
          款項列表
        </b-link>
      </div>
    </b-alert>
    <!-- :quotation-options="quotationOptions"
      :template-type-options="templateTypeOptions"
      :customer-options="customerOptions"
      :product-options="productOptions"
      :product-unit-options="productUnitOptions"
      :template-remark-options="templateRemarkOptions" 
      
      :project-options="projectOptions"-->
    <receipt-description-edit-tab-information
      v-if="receiptDescriptionData"
      :receipt-description-data="receiptDescriptionData"
      @refetch-data="refetchData"
      class="p-sm-2"
    />

    <!-- @refetch-data="refetchData" -->
  </component>
</template>

<script>
import { BCard, BAlert, BLink, BTabs, BTab } from "bootstrap-vue";
import { ref, onUnmounted, onMounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import receiptDescriptionStoreModule from "../receiptDescriptionStoreModule";
import receiptDescriptionEditTabInformation from "./receiptDescriptionEditTabInformation.vue";
import axiosIns from "@/libs/axios";
import {getDateTime} from "@/libs/helper";

export default {
  components: {
    receiptDescriptionEditTabInformation,
    BCard,
    BAlert,
    BTabs,
    BTab,
    BLink,
  },
  setup() {
    const receiptDescriptionData = ref({ 
          id: 0,
          name: null,
          description: null,
          is_active: 1,
      }
   );
    const receiptDescription = {
          id: 0,
          name: null,
          description: null,
          is_active: 1,
    };

    const receiptDescription_APP_STORE_MODULE_NAME = "receipt-description";

    if (!store.hasModule(receiptDescription_APP_STORE_MODULE_NAME))
      store.registerModule(receiptDescription_APP_STORE_MODULE_NAME, receiptDescriptionStoreModule);

    // UnRegister on leave
    onUnmounted(() => {
      if (store.hasModule(receiptDescription_APP_STORE_MODULE_NAME))
        store.unregisterModule(receiptDescription_APP_STORE_MODULE_NAME);
    });

    const refetchData = () => {
      if (router.currentRoute.name == "receipt-description-create") {
          receiptDescriptionData.value = receiptDescription;
      } else {
        store
          .dispatch("receipt-description/fetchReceiptDescription", {
            id: router.currentRoute.params.id,
          })
          .then((response) => {
            receiptDescriptionData.value = response.data.receipt_description;
          })
          .catch((error) => {
            console.log("error when fetching receipt description", error);
            if (error.response.status === 404) {
              receiptDescriptionData.value = undefined;
            }
          });
      }
    };




    onMounted(() => {
      refetchData();
    });

    return {
      refetchData,
      receiptDescriptionData
    };
  },
};
</script>
